import { useEffect, useState } from "react";
import { MessageSquareText, X, Sparkles } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import AssistantChat from "./AssistantChat";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const openHandler = () => setOpen(true);
    window.addEventListener("open-assistant", openHandler);
    return () => window.removeEventListener("open-assistant", openHandler);
  }, []);

  return (
    <>
      <button
        data-testid="assistant-launcher"
        onClick={() => setOpen((o) => !o)}
        aria-label="Open AI Fitness Assistant"
        className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-primary text-primary-foreground pl-4 pr-5 h-14 rounded-full shadow-xl hover:scale-105 transition-transform"
      >
        {open ? <X size={22} /> : <MessageSquareText size={22} />}
        <span className="hidden sm:block text-xs uppercase tracking-[0.12em] font-bold">Ask AI</span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.96 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-24 right-3 sm:right-5 z-50 w-[calc(100vw-1.5rem)] sm:w-[400px] h-[70vh] sm:h-[600px] max-h-[80vh] bg-card border border-border rounded-2xl shadow-2xl p-4 flex flex-col"
            data-testid="assistant-widget"
          >
            <AssistantChat variant="widget" />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
